import { Cookies } from 'react-cookie'

const _COMPANY_SPECIFIC_SUBDOMAIN_NAME = 'zocksCompanySpecificSubdomain'
const _PREFERRED_AUTH_METHOD_NAME = 'zocksPreferredAuthMethod'
const _PREFERRED_AUTH_METHOD_CANDIDATE_NAME = 'zocksPreferredAuthMethodCandidate'
const _LOGIN_APP_BASE_URL = import.meta.env.REACT_APP_LOGIN_APP_URL!
const cookies = new Cookies()

const getCookieOptions = () => ({ path: '/', domain: window.location.hostname.endsWith('localhost') ? '.dev.localhost' : '.zocks.io' })
const getCompanySpecificSubdomain = () => cookies.get(_COMPANY_SPECIFIC_SUBDOMAIN_NAME)
export const shouldUseCompanySso = (): boolean => {
  return !!getCompanySpecificSubdomain()
}

const removePreferredAuthMethod = () => {
  cookies.remove(_PREFERRED_AUTH_METHOD_NAME, getCookieOptions())
}
const removePreferredAuthMethodCandidate = () => {
  cookies.remove(_PREFERRED_AUTH_METHOD_CANDIDATE_NAME, getCookieOptions())
}

export const getLoginAppBaseUrl = () =>
  shouldUseCompanySso() ? _LOGIN_APP_BASE_URL.replace('://console.', `://${cookies.get(_COMPANY_SPECIFIC_SUBDOMAIN_NAME)}.`) : _LOGIN_APP_BASE_URL

export const handleCompanySsoLogout = () => {
  if (shouldUseCompanySso()) {
    removePreferredAuthMethod()
    removePreferredAuthMethodCandidate()
  }
}
